import { React, useState, useEffect } from "react";

const PopUpdreamCatcherResults = ({ resultsData, catMid, marketType }) => {
    const resultData = resultsData;

    useEffect(() => {
        console.log("Market Type:", marketType);
        console.log("Results Data:", resultsData);
    }, [resultsData, marketType]);

    const dataObj = resultsData;


    const formatMarketStartTime = (dateString) => {
        if (!dateString) return "";
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return "";
        return date.toLocaleString("en-US", {
            month: "numeric",
            day: "numeric",
            year: "numeric",
            hour: "numeric",
            minute: "2-digit",
            second: "2-digit",
            hour12: true
        });
    };

    let One = "";
    let Two = "";
    let Five = "";
    let Ten = "";
    let Twenty = "";
    let Forty = "";

    if (marketType == 42) {
        One = resultData.result == 1 ? "Winner" : "LOSER";
        Two = resultData.result == 2 ? "Winner" : "LOSER";
        Five = resultData.result == 5 ? "Winner" : "LOSER";
        Ten = resultData.result == 10 ? "Winner" : "LOSER";
        Twenty = resultData.result == 20 ? "Winner" : "LOSER";
        Forty = resultData.result == 40 ? "Winner" : "LOSER";
    }

    return (
        <div>
            <div id="ResultsData">
                <div class="left-content site_family">

                    <div id="dream-catcher" style={{ display: marketType == 42 ? "" : "none" }} >
                        <div className="left-content">
                            <div className="card">

                                <div className="card-header">
                                    {dataObj.evt_od} -
                                    (<b>Round Id = </b>{catMid})
                                </div>

                                <div className="card-body">

                                    <div style={{ textAlign: "center", marginBottom: 20 }}>
                                        <h2>Dream Catcher</h2>

                                        <div
                                            style={{
                                                fontSize: 60,
                                                fontWeight: "bold",
                                                color: "#cf8d2e"
                                            }}
                                        >
                                            {resultData.result}
                                        </div>

                                        <div style={{ fontSize: 18 }}>
                                            Winning Number
                                        </div>
                                    </div>

                                    <div className="market-runners">
                                        <div className="runner-runner dream-runner">
                                            <h4>1</h4>
                                            <div className="runner-disabled">{One}</div>
                                        </div>
                                    </div>

                                    <div className="market-runners">
                                        <div className="runner-runner dream-runner">
                                            <h4>2</h4>
                                            <div className="runner-disabled">{Two}</div>
                                        </div>
                                    </div>

                                    <div className="market-runners">
                                        <div className="runner-runner dream-runner">
                                            <h4>5</h4>
                                            <div className="runner-disabled">{Five}</div>
                                        </div>
                                    </div>

                                    <div className="market-runners">
                                        <div className="runner-runner dream-runner">
                                            <h4>10</h4>
                                            <div className="runner-disabled">{Ten}</div>
                                        </div>
                                    </div>

                                    <div className="market-runners">
                                        <div className="runner-runner dream-runner">
                                            <h4>20</h4>
                                            <div className="runner-disabled">{Twenty}</div>
                                        </div>
                                    </div>

                                    <div className="market-runners">
                                        <div className="runner-runner dream-runner">
                                            <h4>40</h4>
                                            <div className="runner-disabled">{Forty}</div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default PopUpdreamCatcherResults;

